import React, { useState, useEffect } from "react";
import { Nav } from "react-bootstrap";
import {
    FaBars,
    FaTh,
    FaUser,
    FaEnvelopeOpenText,
    FaClipboardList,
    FaFileAlt,
    FaCog,
    FaSignOutAlt,
    FaQuestion,
    FaTimes,
} from "react-icons/fa";
import "bootstrap/dist/css/bootstrap.min.css";
import { useNavigate, useLocation } from "react-router-dom";
// import LogOutModal from "../modal/logOutModal";

const Sidebar = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [isSidebarOpen, setIsSidebarOpen] = useState(true);
    const [isSmallScreen, setIsSmallScreen] = useState(false);
    // const [isDeletePopupVisible, setDeletePopupVisible] = useState(false);

    // const handleOpenDeletePopup = () => setDeletePopupVisible(true);

    // const handleCloseDeletePopup = () => setDeletePopupVisible(false);

    // const handleConfirmDelete = () => {
    //     alert('Log Out Successfully!');
    //     setDeletePopupVisible(false);
    // }

    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
    };

    const handleResize = () => {
        const smallScreen = window.innerWidth <= 768;
        setIsSmallScreen(smallScreen);
        setIsSidebarOpen(!smallScreen);
    };

    useEffect(() => {
        window.addEventListener("resize", handleResize);
        handleResize();
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    return (
        <div style={{ display: "flex" }}>
            <div
                style={{
                    ...styles.sidebarContainer,
                    width: isSidebarOpen ? "220px" : "0",
                    overflow: isSidebarOpen ? "auto" : "hidden",
                }}
            >
                <Nav className="flex-column" style={styles.nav}>
                    <Nav.Item>
                        <Nav.Link
                            onClick={() => navigate("/mainAdminPannel")}
                            style={
                                location.pathname === "/mainAdminPannel" ? styles.activeNavLink : styles.navLink
                            }
                        >
                            <FaTh
                                style={
                                    location.pathname === "/mainAdminPannel" ? styles.activeIcon : styles.icon
                                }
                            />
                            Dashboard
                        </Nav.Link>
                    </Nav.Item>

                    <Nav.Item>
                        <Nav.Link
                            onClick={() => navigate("/userMangement")}
                            style={
                                location.pathname === "/userMangement" ? styles.activeNavLink : styles.navLink
                            }
                        >
                            <FaUser
                                style={
                                    location.pathname === "/userMangement" ? styles.activeIcon : styles.icon
                                }
                            />
                            User Management
                        </Nav.Link>
                    </Nav.Item>

                    <Nav.Item>
                        <Nav.Link
                            onClick={() => navigate("/subscriptionMangement")}
                            style={
                                location.pathname === "/subscriptionMangement" ? styles.activeNavLink : styles.navLink
                            }
                        >
                            <FaEnvelopeOpenText
                                style={
                                    location.pathname === "/subscriptionMangement" ? styles.activeIcon : styles.icon
                                }
                            />
                            Subscription Mangemnt
                        </Nav.Link>
                    </Nav.Item>

                    <Nav.Item>
                        <Nav.Link
                            onClick={() => navigate("/feedbackMangement")}
                            style={
                                location.pathname === "/feedbackMangement" ? styles.activeNavLink : styles.navLink
                            }
                        >
                            <FaClipboardList
                                style={
                                    location.pathname === "/feedbackMangement" ? styles.activeIcon : styles.icon
                                }
                            />
                            Feedback Management
                        </Nav.Link>
                    </Nav.Item>

                    <Nav.Item>
                        <Nav.Link
                            onClick={() => navigate("/subscriptions")}
                            style={
                                location.pathname === "/subscriptions"
                                    ? styles.activeNavLink
                                    : styles.navLink
                            }
                        >
                            <FaFileAlt
                                style={
                                    location.pathname === "/subscriptions"
                                        ? styles.activeIcon
                                        : styles.icon
                                }
                            />
                            Subscription
                        </Nav.Link>
                    </Nav.Item>

                    <Nav.Item>
                        <Nav.Link
                            onClick={() => navigate("/settings")}
                            style={
                                location.pathname === "/settings"
                                    ? styles.activeNavLink
                                    : styles.navLink
                            }
                        >
                            <FaCog
                                style={
                                    location.pathname === "/settings"
                                        ? styles.activeIcon
                                        : styles.icon
                                }
                            />
                            Settings
                        </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                        <Nav.Link
                            onClick={() => navigate("/questionnaire")}
                            style={
                                location.pathname === "/questionnaire"
                                    ? styles.activeNavLink
                                    : styles.navLink
                            }
                        >
                            <FaQuestion
                                style={
                                    location.pathname === "/questionnaire"
                                        ? styles.activeIcon
                                        : styles.icon
                                }
                            />
                            Questionnaire
                        </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                        <hr style={styles.separator} />
                        <Nav.Link
                            // onClick={handleOpenDeletePopup}
                            style={
                                location.pathname === "handleOpenDeletePopup"
                                    ? styles.activeNavLink
                                    : styles.navLink
                            }
                        >
                            <FaSignOutAlt
                                style={
                                    location.pathname === "handleOpenDeletePopup"
                                        ? styles.activeIcon
                                        : styles.icon
                                }
                            />
                            Logout
                        </Nav.Link>
                    </Nav.Item>
                </Nav>
            </div>

            <div style={{ ...styles.contentArea, marginLeft: isSidebarOpen ? "220px" : "0" }}>
                {isSmallScreen && (
                    <button style={styles.burgerButton} onClick={toggleSidebar}>
                        {isSidebarOpen ? <FaTimes /> : <FaBars />}
                    </button>
                )}
            </div>
            {/* <LogOutModal
                show={isDeletePopupVisible}
                handleClose={handleCloseDeletePopup}
                handleConfirm={handleConfirmDelete}
            /> */}
        </div>
    );
};

const styles = {
    sidebarContainer: {
        backgroundColor: "white",
        padding: "10px",
        height: "100vh",
        transition: "width 0.3s",
        position: "fixed",
        borderLeft: "2px solid pink",
        boxShadow: "1px 0 1px rgba(0,0,0,0.1)",
    },

    nav: {
        fontSize: "14px",
    },
    navLink: {
        color: "#495057",
        display: "flex",
        alignItems: "start",
        textDecoration: "none",
        padding: "12px 10px",
        borderRadius: "4px",
        marginBottom: "5px",
        transition: "all 0.3s",
    },
    activeNavLink: {
        color: "#fff",
        backgroundColor: "#D87F8A",
        display: "flex",
        alignItems: "center",
        textDecoration: "none",
        padding: "10px 10px",
        borderRadius: "4px",
        marginBottom: "5px",
        transition: "all 0.3s",
    },
    icon: {
        marginRight: "10px",
        fontSize: "18px",
        color: "#D87F8A",
    },
    activeIcon: {
        marginRight: "10px",
        fontSize: "18px",
        color: "#fff",
    },
    separator: {
        margin: "10px 0",
        borderColor: "grey",
    },
    footerContainer: {
        marginTop: "auto",
    },
    contentArea: {
        flex: 1,
        transition: "margin-left 0.3s",
    },
    burgerButton: {
        fontSize: "20px",
        margin: "10px",
        cursor: "pointer",
        background: "none",
        border: "none",
        color: "#D87F8A",
    },
    mainContent: {
        padding: "20px",
    },
};

export default Sidebar;